// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DgZenkgfYoMN7m7bbj0D{flex-direction:column;gap:12px;display:flex}.JZO_EqHqK9UlRj_K4BFE{justify-content:space-between;align-items:center;gap:12px;padding-top:8px;padding-bottom:8px;display:flex}.JZO_EqHqK9UlRj_K4BFE .igtUIXACp0upXnAC7r_S{align-items:center;gap:8px;display:flex}.Zw0aeJ4FdUAMaeyEucEl{grid-template-columns:1fr max-content;align-items:center;gap:8px;display:grid}.mDqhC_qE8nwRLMofIMaV{flex-direction:column;gap:4px;display:flex}.mDqhC_qE8nwRLMofIMaV .EsuLhO6JnlIO3hKMG3fS{padding-top:3.5px;padding-bottom:3.5px;display:flex}.QUXWkL2lCXwR8syEc7bg{flex-direction:column;gap:24px;display:flex}.QUXWkL2lCXwR8syEc7bg .b_6pCKiVSioIjonh5rEE{flex-direction:column;gap:8px;display:flex}.QUXWkL2lCXwR8syEc7bg .b_6pCKiVSioIjonh5rEE .TpqWfOLqM8g50p1hcLHF{list-style-type:initial;margin-left:21px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `DgZenkgfYoMN7m7bbj0D`,
	"wrapEnroll": `JZO_EqHqK9UlRj_K4BFE`,
	"left": `igtUIXACp0upXnAC7r_S`,
	"copyInput": `Zw0aeJ4FdUAMaeyEucEl`,
	"webhookWrap": `mDqhC_qE8nwRLMofIMaV`,
	"helper": `EsuLhO6JnlIO3hKMG3fS`,
	"emptyWebhookWrap": `QUXWkL2lCXwR8syEc7bg`,
	"info": `b_6pCKiVSioIjonh5rEE`,
	"list": `TpqWfOLqM8g50p1hcLHF`
};
export default ___CSS_LOADER_EXPORT___;
